// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__erySS"};